export enum ConfigSettingsEnvironments {
  Development = "dev",
  Production = "prod",
}

export const ConfigSettingsKeyPerEnvironment = {
  ["local"]: ConfigSettingsEnvironments.Development,
  ["development"]: ConfigSettingsEnvironments.Development,
  ["staging"]: ConfigSettingsEnvironments.Production,
  ["production"]: ConfigSettingsEnvironments.Production,
};
